import { render, staticRenderFns } from "./UserRightsTable.vue?vue&type=template&id=04c99946&scoped=true"
import script from "./UserRightsTable.vue?vue&type=script&lang=ts"
export * from "./UserRightsTable.vue?vue&type=script&lang=ts"
import style0 from "./UserRightsTable.vue?vue&type=style&index=0&id=04c99946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c99946",
  null
  
)

export default component.exports